import Vue from 'vue';
import Router from 'vue-router';
import store from './store';

Vue.use(Router);

function logPrevious (to, from, next) {
    localStorage.setItem("previousPath", from.path);
    next();
}


function isAuthenticated() {
    return localStorage.getItem('token') !== null || localStorage.getItem('authProvider') === 'okta';
}

function requireAuth (to, from, next) {
    if(isAuthenticated()){
        if (store.getters.isLoggedIn) {
            next();
        }else {
            next('/');
        }
    }else {
        next('/');
    }
}

function requireSuperUser (to, from, next) {
    if (!isAuthenticated() || !store.getters.isLoggedIn) {
        next('/');
        return;
    }

    if (store.getters.isShowAdminUsersAccess) {
        next();
        return;
    }

    next('/transactions');
}

function requireOnOffRampAccess (to, from, next) {
    if (!isAuthenticated() || !store.getters.isLoggedIn) {
        next('/');
        return;
    }

    if (store.getters.isOnOffRampAccess) {
        next();
        return;
    }

    next('/transactions');
}

function checkLogged (to, from, next) {

    if(isAuthenticated()){
        if (store.getters.isLoggedIn) {
            next('/users');
        }else{
            next('/');
        }
    }else {
        next('/');
    }
}

function loginAvailable (to, from, next) {

    if(isAuthenticated()){
        if (store.getters.isLoggedIn) {
            next('/users');
        }else{
            next();
        }
    }else{
        next();
    }
}


export default new Router({
    routes: [
        {
            path: '/payments',
            beforeEnter: requireAuth,
            component: () => import(/* webpackChunkName: "merchant" */ './views/mainlayout'),
            children: [
                {
                    path: '/conversion',
                    name: 'Conversion',
                    meta: {
                        title: 'Конверсия'
                    },

                    component: () => import( './views/conversion')
                },
                {
                    path: '/conversion-merchant',
                    name: 'MerchantConversion',
                    meta: {
                        title: 'Конверсия мерчантов'
                    },

                    component: () => import( './views/conversion/merchant-conversion')
                },
                {
                    path: '/bookkeeping',
                    name: 'Биллинг',
                    meta: {
                        title: 'Биллинг'
                    },

                    component: () => import('./views/bookkeeping/bookkeeping')
                },

                {
                    path: '/bookkeepingsys',
                    name: 'Бухгалтерия системы',
                    meta: {
                        title: 'Бухгалтерия системы'
                    },

                    component: () => import('./views/bookkeeping/bookkeepingSystem')
                },

                {
                    path: '/balance-transfer',
                    name: 'Переносы балансов',
                    meta: {
                        title: 'Переносы балансов'
                    },

                    component: () => import('./views/balance-transfer/BalanceTransferList')
                },

                {
                    path: '/external-domains',
                    name: 'ExternalDomains',
                    meta: {
                        title: 'Внешние домены'
                    },
                    component: () => import('./views/externaldomain/ExternalDomainList')
                },

                {
                    path: '/profile-registries',
                    name: 'ProfileRegistries',
                    meta: {
                        title: 'Реестры профилей'
                    },
                    component: () => import('./views/profileregistry/ProfileRegistryList')
                },

                {
                    path: '/dictionaries',
                    name: 'Dictionaries',
                    meta: {
                        title: 'Справочники'
                    },
                    component: () => import('./views/dictionaries/Dictionaries')
                },
                {
                    path: '/on-off-ramp',
                    name: 'OnOffRamp',
                    meta: {
                        title: 'On/off-ramp'
                    },
                    beforeEnter: requireOnOffRampAccess,
                    component: () => import('./views/onofframp/OnOffRampList')
                },
                {
                    path: '/on-off-ramp/new',
                    name: 'OnOffRampNew',
                    meta: {
                        title: 'On/off-ramp'
                    },
                    beforeEnter: requireOnOffRampAccess,
                    component: () => import('./views/onofframp/OnOffRampForm')
                },
                {
                    path: '/on-off-ramp/chain',
                    name: 'OnOffRampEdit',
                    meta: {
                        title: 'On/off-ramp'
                    },
                    beforeEnter: requireOnOffRampAccess,
                    component: () => import('./views/onofframp/OnOffRampForm')
                },
                {
                    path: '/on-off-ramp/off-ramp/new',
                    name: 'OffRampNew',
                    meta: {
                        title: 'On/off-ramp'
                    },
                    beforeEnter: requireOnOffRampAccess,
                    component: () => import('./views/onofframp/OffRampForm')
                },
                {
                    path: '/on-off-ramp/off-ramp/chain',
                    name: 'OffRampEdit',
                    meta: {
                        title: 'On/off-ramp'
                    },
                    beforeEnter: requireOnOffRampAccess,
                    component: () => import('./views/onofframp/OffRampForm')
                },

                {
                    path: '/hidden',
                    name: 'Плейграунд',
                    meta: {
                        title: 'Плейграунд'
                    },

                    component: () => import('./views/_dtConstructPlayground/dtConstructPage')
                },

                {
                    path: '/banks',
                    name: 'Банки',
                    meta: {
                        title: 'Банки'
                    },

                    component: () => import('./views/banks/banks')
                },

                {
                    path: '/banks/:id',
                    name: 'BankInfo',
                    meta: {
                        title: 'Банк'
                    },
                    component: () => import('./views/banks/BankInfo')
                },

                {
                    path: '/payshistory',
                    name: 'История выплат',
                    meta: {
                        title: 'История выплат'
                    },

                    component: () => import( './views/pays/Payshistory')
                },

                {
                    path: '/gate_balancer',
                    name: 'Балансировщики',
                    meta: {
                        title: 'Балансировщики'
                    },

                    component: () => import( './views/gatebalancer/GateBalancerList')
                },
                {
                    path: '/gate_balancer/:id',
                    name: 'Балансировщики',
                    meta: {
                        title: 'Балансировщики'
                    },

                    component: () => import( './views/gatebalancer/GateBalancer')
                },
                {
                    path: '/ftd_probe_config',
                    name: 'FTD Probe',
                    meta: {
                        title: 'FTD Probe конфигурации'
                    },
                    component: () => import('./views/ftdprobeconfig/FtdProbeConfigList')
                },
                {
                    path: '/ftd_probe_config/:id',
                    name: 'FtdProbeConfigPage',
                    meta: {
                        title: 'FTD Probe конфигурация'
                    },
                    component: () => import('./views/ftdprobeconfig/FtdProbeConfigPage')
                },
                {
                    path: '/ftd_checks',
                    name: 'FTD Checks',
                    meta: {
                        title: 'FTD Probe Checks'
                    },
                    component: () => import('./views/ftdcheck/FtdCheckList')
                },
                {
                    path: '/ftd_check/:id',
                    name: 'FtdCheckDetails',
                    meta: {
                        title: 'FTD Check Details'
                    },
                    component: () => import('./views/ftdcheck/FtdCheckDetails')
                },
                {
                    path: '/error_category_mappings',
                    name: 'ErrorCategoryMappings',
                    meta: {
                        title: 'Маппинг категорий ошибок'
                    },
                    component: () => import('./views/errorcategorymappings/ErrorCategoryMappingsList')
                },
                {
                    path: '/mcc',
                    name: 'MCC',
                    meta: {
                        title: 'MCC'
                    },

                    component: () => import( './views/mcc/MCC')
                },
                {
                    path: '/limits',
                    name: 'Лимиты',
                    meta: {
                        title: 'Лимиты'
                    },

                    component: () => import( './views/limits/LimitsDashboard')
                },
                {
                    path: '/transactions',
                    name: 'Оплаты',
                    meta: {
                        title: 'Оплаты'
                    },
                    beforeEnter: logPrevious,
                    component: () => import(/* webpackChunkName: "trans" */ './views/transactions/Transactions')
                },
                {
                    path: '/transactions/info/:id/',
                    name: 'Информация о транзакции',
                    meta: {
                        title: 'Информация о транзакции'
                    },

                    component: () => import('./views/transactions/Transactions_info')
                },
                {
                    path: '/ars-orders',
                    name: 'ARS-ордера',
                    meta: {
                        title: 'ARS-ордера'
                    },

                    component: () => import('./views/arsorders/ArsOrders')
                },
                {
                    path: '/ars-orders/info/:id',
                    name: 'Информация о ARS-ордере',
                    meta: {
                        title: 'Информация о ARS-ордере',
                        cardKind: 'order'
                    },

                    component: () => import('./views/arsorders/ArsOrders_info')
                },
                // Платёж без ордера — отдельный маршрут, а не тот же с другим идентификатором:
                // ars-orders собирает эти карточки разными ручками, и по одному лишь
                // идентификатору отличить их нельзя — external_order_id задаёт мерчант.
                {
                    path: '/ars-orders/payments/:id',
                    name: 'Информация о платеже ARS',
                    meta: {
                        title: 'Информация о платеже ARS',
                        cardKind: 'payment'
                    },

                    component: () => import('./views/arsorders/ArsOrders_info')
                },
                {
                    path: '/Gate',
                    name: 'Гейты',
                    meta: {
                        title: 'Гейты'
                    },

                    component: () => import(/* webpackChunkName: "trans" */ './views/Gate/GatePage')
                },
                {
                    path: '/newUsers',
                    name: 'Заявки на регистрации',
                    meta: {
                        title: 'Заявки на регистрации'
                    },

                    component: () => import(/* webpackChunkName: "trans" */ './views/users/NewUsers')
                },
                {
                    path: '/logs',
                    name: 'logs',
                    meta: {
                        title: 'Лог операций'
                    },

                    component: () => import(/* webpackChunkName: "trans" */ './views/log/Log')
                },
                {
                    path: '/transaction-request',
                    name: 'transactionRequestLogs',
                    meta: {
                        title: 'Лог запросов транзакции'
                    },
                    component: () => import(/* webpackChunkName: "trans" */ './views/log/TransactionRequestLog')
                },
                {
                    path: '/processing-id-to-order-id',
                    name: 'ProcessingIdToOrderIdPage',
                    meta: {
                        title: 'processing id -> order id'
                    },

                    component: () => import(/* webpackChunkName: "trans" */ './views/util/ProcessingIdToOrderId')
                },
                {
                    path: '/processing-acc-dec',
                    name: 'ProcessingAccDec',
                    meta: {
                        title: 'Accept / Decline'
                    },

                    component: () => import(/* webpackChunkName: "trans" */ './views/util/ProcessingAccDec')
                },
                {
                    path: '/processing-chargeback',
                    name: 'ProcessingChargeback',
                    meta: {
                        title: 'Chargeback'
                    },

                    component: () => import(/* webpackChunkName: "trans" */ './views/util/ProcessingChargeback.vue')
                },
                {
                  path: '/processing-visa-verify',
                  name: 'ProcessingVisaVerify',
                  meta: {
                    title: 'Visa Verify'
                  },

                  component: () => import(/* webpackChunkName: "trans" */ './views/util/ProcessingVisaVerify.vue')
                },
                {
                  path: '/processing-mastercard-colab',
                  name: 'ProcessingMastercardColab',
                  meta: {
                    title: 'Mastercard Colab'
                  },

                  component: () => import(/* webpackChunkName: "trans" */ './views/util/ProcessingMastercardColab.vue')
                },

                {
                    path: '/processing-refund',
                    name: 'ProcessingRefund',
                    meta: {
                        title: 'Refund'
                    },

                    component: () => import(/* webpackChunkName: "trans" */ './views/util/ProcessingRefund.vue')
                },
                {
                    path: '/withdrawal-split-retry',
                    name: 'WithdrawalSplitRetry',
                    meta: {
                        title: 'Retry Split Withdrawal'
                    },

                    component: () => import(/* webpackChunkName: "trans" */ './views/util/WithdrawalSplitRetry.vue')
                },
                {
                    path: '/embermind-bw-decision',
                    name: 'EmbermindBwDecision',
                    meta: {
                        title: 'BW-решение Embermind'
                    },

                    component: () => import(/* webpackChunkName: "trans" */ './views/util/EmbermindBwDecision.vue')
                },
                {
                    path: '/create-secrets',
                    name: 'CreateSecrets',
                    meta: {
                        title: 'Создание секретов'
                    },
                    component: () => import(/* webpackChunkName: "trans" */ './views/util/CreateSecrets.vue')
                },
                {
                    path: '/statements',
                    name: 'Statements',
                    meta: {
                        title: 'Выписки'
                    },
                    component: () => import(/* webpackChunkName: "trans" */ './views/statements/Statements')
                },
                {
                    path: '/batch-mass-check',
                    name: 'BatchMassCheck',
                    meta: {
                        title: 'Масс проверка'
                    },
                    component: () => import(/* webpackChunkName: "trans" */ './views/batchmasscheck/BatchMassCheckList')
                },
                {
                    path: '/batch-mass-check/:taskId',
                    name: 'BatchMassCheckDetails',
                    meta: {
                        title: 'Детали масс проверки'
                    },
                    component: () => import(/* webpackChunkName: "trans" */ './views/batchmasscheck/BatchMassCheckDetails')
                },
                {
                    path: '/fiscal-profiles',
                    name: 'FiscalProfiles',
                    beforeEnter: requireSuperUser,
                    meta: {
                        title: 'Фискальные кассы'
                    },
                    component: () => import(/* webpackChunkName: "trans" */ './views/fiscalprofiles/FiscalProfileList')
                },
                {
                    path: '/kz-p2p-cards',
                    name: 'KzP2pCardPool',
                    beforeEnter: requireSuperUser,
                    meta: {
                        title: 'Пул карт P2P'
                    },
                    component: () => import(/* webpackChunkName: "trans" */ './views/kzP2pCards/KzP2pCardPool')
                },
                {
                    path: '/gate-experiments',
                    name: 'GateExperiments',
                    meta: {
                        title: 'Эксперименты'
                    },
                    component: () => import(/* webpackChunkName: "trans" */  './views/gateexperiments/GateExperiments')
                },
                {
                    path: '/gate-experiments/:id',
                    name: 'GateExperimentPage',
                    meta: {
                        title: 'Эксперимент'
                    },
                    component: () => import(/* webpackChunkName: "trans" */  './views/gateexperiments/GateExperimentPage')
                },
                {
                    path: '/smartpayments/report',
                    name: 'SmartpaymentsReport',
                    meta: {
                        title: 'Smartpayments report'
                    },

                    component: () => import(/* webpackChunkName: "trans" */ './views/smartpayments/SmartpaymentsReport')
                },
                {
                    path: '/aggregators',
                    name: 'Список агрегаторов',
                    meta: {
                        title: 'Список агрегаторов'
                    },

                    component: () => import(/* webpackChunkName: "aggregators" */ './views/aggregators/Aggregatorlayout'),
                    children: [
                        {
                            path: '/aggregators',
                            name: 'Список агрегаторов',
                            meta: {
                                title: 'Список агрегаторов'
                            },
                            component: () => import(/* webpackChunkName: "users" */ './views/aggregators/Aggregators'),
                        },
                        {
                            path: '/aggregators/aggregatorpage/:id/:merchantKey',
                            name: 'Агрегатор',
                            meta: {
                                title: 'Агрегатор'
                            },

                            component: () => import('./views/aggregatorpage/Aggregatorpage')
                        },
                    ]
                },
                {
                    path: '/users',
                    name: 'Список пользователей',
                    meta: {
                        title: 'Список пользователей'
                    },

                    component: () => import(/* webpackChunkName: "users" */ './views/users/Userlayout'),
                    children: [
                        {
                            path: '/admin-user',
                            name: 'adminUsers',
                            meta: {
                                title: 'Список администраторов'
                            },

                            component: () => import(/* webpackChunkName: "users" */ './views/users/AdminUsers'),
                        },
                        {
                            path: '/admin-user/:id',
                            name: 'adminUser',
                            meta: {
                                title: 'Адинистратор'
                            },

                            component: () => import(/* webpackChunkName: "users" */ './views/users/AdminUser'),
                        },
                        {
                            path: '/users',
                            name: 'Список пользователей',
                            meta: {
                                title: 'Список пользователей'
                            },

                            component: () => import(/* webpackChunkName: "users" */ './views/users/Users'),
                        },
                        {
                            path: '/users/userpage/:id/:merchantKey',
                            name: 'Пользователь',
                            meta: {
                                title: 'Пользователь'
                            },

                            component: () => import('./views/userpage/Userpage')
                        },
                        {
                            path: '/gate/gateInfo/:id',
                            name: 'Пользователь',
                            meta: {
                                title: 'Пользователь'
                            },

                            component: () => import( './views/Gate/GateInfo')
                        },
                        {
                            path: '/account/accountInfo/:id',
                            name: 'Счет',
                            meta: {
                                title: 'Счет'
                            },

                            component: () => import( './views/accouts/accountInfo')
                        },
                        {
                            path: '/merchant-groups/:id',
                            name: 'Группа мерчантов',
                            meta: {
                                title: 'Группа мерчантов'
                            },

                            component: () => import('./views/merchantgroups/MerchantGroupPage')
                        },
                        {
                            path: '/ip-groups/:id',
                            name: 'Группа IP',
                            meta: {
                                title: 'Группа IP'
                            },

                            component: () => import('./views/ipgroups/IpGroupPage')
                        }

                    ]
                }

            ]
        },


        {
            path: '/',
            beforeEnter: loginAvailable,
            name: 'Login',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "login" */ './views/login/Login.vue')
        },
        {
            path: '*',
            beforeEnter: checkLogged,
            meta: {
                title: 'Мерчант'
            },
        },


    ]
})
